"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConstructorContextDispatch = void 0;

var _react = require("react");

var _constructorContext = require("../constructorContext");

var useConstructorContextDispatch = function useConstructorContextDispatch() {
  var _useContext = (0, _react.useContext)(_constructorContext.constructorContext),
      dispatch = _useContext.dispatch;

  return dispatch;
};

exports.useConstructorContextDispatch = useConstructorContextDispatch;